import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import menuToggler from '../../bdcoreCandidates/menuToggler';

const styles = css`
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  padding: 60px 20px 20px 20px;
  overflow-y: scroll;
  z-index: 1010;
  background-color: #003451;
  @media (min-width: 992px) {
    display: none !important;
  }
  .ToggleMenu_menu {
    list-style: none;
    padding: 0 0 15px 0;
    margin: 0;
    padding: 0;
    background-color: #c8d8d9;
    @media(max-width: 991px) {
      background-color: transparent;
    }
  }
  .ToggleMenu_menuItem {
    list-style: none;
    padding: 0;
    border-bottom: 1px solid #8da9ab;
    @media(max-width: 991px) {
      border-bottom: 1px solid #333333;
    }
    li {
      font-weight: 700;
      font-size: 13px;
      line-height: 30px;
      @media(max-width: 991px) {
        height: 45px;
        display: flex;
        align-items: center;
      }
      a {
        color: #B3CED0;
        transition: all .3s ease-out;
        &:hover {
          color: #DA521F;
          transition: all .3s ease-out;
        }
      }
    }

  .ToggleMenu_subMenu {
    display: none;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .ToggleMenu_subMenu-active {
    display: inline;
  }

  .ToggleMenu_menuHeading {
    color: #FFFFFF;
    font-size: 16px;
    background-image: url('images/icon-triangle-gold.svg');
    background-position: 95% center;
    background-repeat: no-repeat;
    cursor: pointer;
    height: 50px;
    display: flex;
    align-items: center;
    transition: all .3s ease-out;
    &:hover {
      color: #DA521F;
      transition: all .3s ease-out;
    }
  }
    @media (min-width: 992px) {
      height: 88px;
      border-bottom: 1px solid $color3;
      background-color: $color3;
      padding: 0;
      margin: 0;
      vertical-align: top;
      list-style: none;
      text-align: right;
      padding: 30px 60px;
      width: 100%;
      .ToggleMenu_subMenu {
        display: inline;
      }
      li {
        font-weight: 600;
        font-size: 15px;
        line-height: 24px;
        display: inline-block;
        a {
          color: $color2;
          background-color: rgba(255,255,255,.8);
          padding: 8px 10px;
          margin: 0 0 0 5px;
        }
      }
      .ToggleMenu_menuHeading {
        color: $color5;
        background-color: transparent;
        font-weight: 700;
        float: left;
        text-transform: uppercase;
        background-image: none;
        cursor: default;
        @media(min-width: 992px) {
          color: #074585;
        }
      }
    }
  }
  .ToggleMenu_menu_MobileOnly {
    display: block;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .ToggleMenu_menuClose {
    display: block;
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
    background-image: url('/images/icon-close-white.svg');
    background-repeat: no-repeat;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .ToggleMenu_bottomMenu {
    list-style: none;
    padding: 0;
    margin: 0 0 0 -8px;
    background-color: #b3ced0;
    @media(max-width: 991px) {
      background-color: transparent;
    }
    li {
    font-size: 13px;
    line-height: 20px;
    font-weight: 700;
    border-right: 1px solid #333333;
    display: inline-block;
     a {
       color: #B3CED0;
       padding: 8px;
       text-transform: uppercase;
       transition: all .3s ease-out;
       &:hover {
         color: #DA521F;
         transition: all .3s ease-out;
       }
     }
    }
    @media (min-width: 992px) {
      height: 88px;
      border-bottom: 1px solid $color3;
      background-color: $color3;
      padding: 0;
      margin: 0;
      vertical-align: top;
      list-style: none;
      text-align: right;
      padding: 30px 60px;
      width: 100%;
      li {
        font-weight: 600;
        font-size: 15px;
        line-height: 24px;
        display: inline-block;
        border: 0;
        a {
          color: $color2;
          margin: 0 0 0 20px;
          padding: 0;
        }
      }
    }
  }
`;

function ToggleMenu({ isActive, toggleMenu, isActiveMenu, activateMenu }) {
  return (
    <div className={styles} style={{ display: isActive ? 'block' : 'none' }}>
      <button className="ToggleMenu_menuClose" onClick={toggleMenu} />
      <ul className="ToggleMenu_menu">
        <li className="ToggleMenu_menuItem">
          <span tabIndex={0} role="button" className="ToggleMenu_menuHeading" onClick={() => activateMenu('fyh')}>Find Your Home</span>
          <ul className={`${isActiveMenu('fyh') ? 'ToggleMenu_subMenu-active' : ''} ToggleMenu_subMenu`}>
            <li className="ToggleMenu_subMenuItem"><Link name="communities" onClick={toggleMenu}>New Home Communities</Link></li>
            <li className="ToggleMenu_subMenuItem"><Link name="homes" onClick={toggleMenu}>Quick Move-In Homes</Link></li>
            <li className="ToggleMenu_subMenuItem"><Link name="plans" onClick={toggleMenu}>Available Floor Plans</Link></li>
          </ul>
        </li>
        <li className="ToggleMenu_menuItem">
          <span tabIndex={0} role="button" className="ToggleMenu_menuHeading" onClick={() => activateMenu('resources')}>Homebuying Guide</span>
          <ul className={`${isActiveMenu('resources') ? 'ToggleMenu_subMenu-active' : ''} ToggleMenu_subMenu`}>
            {/* <li className="ToggleMenu_subMenuItem">
            <Link name="design-center" onClick={toggleMenu}>Design Center</Link></li> */}
            <li className="ToggleMenu_subMenuItem"><Link name="building-process" onClick={toggleMenu}>Building Process</Link></li>
            <li className="ToggleMenu_subMenuItem"><Link name="energy-savings" onClick={toggleMenu}>Energy Savings</Link></li>
            <li className="ToggleMenu_subMenuItem"><Link name="financing" onClick={toggleMenu}>Financing Your New Home</Link></li>
            <li className="ToggleMenu_subMenuItem"><Link name="why-buy-new" onClick={toggleMenu}>Why Buy New</Link></li>
            <li className="ToggleMenu_subMenuItem"><Link name="faq" onClick={toggleMenu}>Homebuyer FAQ</Link></li>
          </ul>

        </li>
        <li className="ToggleMenu_menuItem">
          <span tabIndex={0} role="button" className="ToggleMenu_menuHeading" onClick={() => activateMenu('about')}>About Us</span>

          <ul className={`${isActiveMenu('about') ? 'ToggleMenu_subMenu-active' : ''} ToggleMenu_subMenu`}>
            <li className="ToggleMenu_subMenuItem"><Link name="difference" onClick={toggleMenu}>About Us</Link></li>
            <li className="ToggleMenu_subMenuItem"><Link name="team" onClick={toggleMenu}>The 70 West Team</Link></li>
            <li className="ToggleMenu_subMenuItem"><Link name="testimonials" onClick={toggleMenu}>Testimonials</Link></li>
            <li className="ToggleMenu_subMenuItem"><Link name="latest-news" onClick={toggleMenu}>Latest News</Link></li>
          </ul>

        </li>
        <li className="ToggleMenu_menuItem">
          <span tabIndex={0} role="button" className="ToggleMenu_menuHeading" onClick={() => activateMenu('contact')}>Contact Us</span>
          <ul className={`${isActiveMenu('contact') ? 'ToggleMenu_subMenu-active' : ''} ToggleMenu_subMenu`}>
            <li className="ToggleMenu_subMenuItem"><Link name="contact-us" onClick={toggleMenu}>Information Request</Link></li>
            <li className="ToggleMenu_subMenuItem"><Link name="customer-care" onClick={toggleMenu}>Customer Care</Link></li>
            <li className="ToggleMenu_subMenuItem"><Link name="service-request" onClick={toggleMenu}>Service Request</Link></li>
            {/* <li className="ToggleMenu_subMenuItem"><Link name="careers"
            onClick={toggleMenu}>Careers</Link></li> */}
          </ul>
        </li>
      </ul>
      <ul className="ToggleMenu_bottomMenu">
        <li><Link name="index" onClick={toggleMenu}>Home</Link></li>
        <li><Link name="gallery" onClick={toggleMenu}>Photo Gallery</Link></li>
        <li><Link name="latest-news" onClick={toggleMenu}>Latest News</Link></li>
        <li><Link name="faq" onClick={toggleMenu}>FAQ</Link></li>
      </ul>
    </div>
  );
}

ToggleMenu.propTypes = {
  isActive: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  activateMenu: PropTypes.func.isRequired,
};

export default menuToggler(ToggleMenu);



// WEBPACK FOOTER //
// ./src/components/Header/ToggleMenu.js